import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { HomePageContent } from 'client/contents/HomePageContent/HomePageContent'

type TProps = {}

const HomePage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <HomePageContent />
    </article>
  )
}

export default HomePage
